// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__zSTUo","logo":"Header_logo__3Cuqg","main-image":"Header_main-image__2Q3So"};